import {  useSelector } from "react-redux";
import { generatePath, useParams  } from "react-router-dom";
// import logo from "../assets/img/logo-Photoroom.png";
import logo from "../assets/img/Full logo white.png";
import userIcon from "../assets/img/UserImage.png";
import navbarimg from "../assets/img/navbar.png";
// import { logoutUser } from "../store/slices/UserSlice";
import { Persona, PersonaSize } from "@fluentui/react";

const Header = (props) => {
    const { clientNameParam } = useParams();
  // redux state
  const { userObj } = useSelector((state) => state.user);

  const personaProps = {
    imageUrl: userObj?.imageUrl ? userObj?.imageUrl : userIcon, // Replace with your image URL
    text: userObj?.userName, // User's name
    //secondaryText: 'john.doe@example.com', // User's email
  };

  // dispatch and navigate
  // const navigate = useNavigate();
  // const dispatch = useDispatch();

  //  ADDED: robust client param validity check (handles undefined, null, empty, "null", "undefined")
  const isClientValid =
    typeof clientNameParam === "string" &&
    clientNameParam.trim() !== "" &&
    clientNameParam !== null &&
    clientNameParam !== undefined;

  //  ADDED: Only redirect if userObj is missing AND we have a valid client param
  if (!userObj && isClientValid) { 
    window.location.href = generatePath("/client/:clientNameParam/", {
                        clientNameParam,
                      });
    return;
  }

  const hideSideBar = () => {
    // eslint-disable-next-line react/prop-types
    props.setHideSidebar(!props.hideSidebar);
  };
  return (
    <>  
      <nav className="navbar navbar-expand-lg bg-light border-bottom dashboard_nav p-0 px-2 pe-0">
        <div className="row w-100">
          <div
            className="d-flex align-items-center gap-5"
            style={{ backgroundColor: "#081634", 
              //height: "98px", 
              position: "fixed" }}
          >
            <button
              className="navbarMenuBtn"
              id="navbarNav"
              onClick={() => {
                hideSideBar();
              }}
              style={{ marginLeft: "10px" }}
            >
              {/* <span className="navbar-toggler-icon"></span> */}
              <img src={navbarimg} className="navbar-toggler-icon" alt="logo" />
            </button>
            <a className="navbar-brand" href={ isClientValid ? generatePath("/client/:clientNameParam/property-form", {
                    clientNameParam,
                  }) : "#" /*  ADDED: safe href fallback if invalid */ }>
              <img src={logo} className="card-img-top logo " alt="logo" />
            </a>

            <div className="d-flex align-items-end gap-2 ms-auto top_nav_right">
              <div className="d-flex flex-row gap-2 align-items-center">
                {/* <div className="search_bar">
                  <i className="fa-solid fa-magnifying-glass"></i>
                  <input
                    type="text"
                    className="form-control"
                    id="floatingInput"
                    placeholder="search"
                  />
                </div> */}
                {/* <i className="fa-solid fa-gear"></i>
                <i className="fa-solid fa-bell"></i> */}

                {/* ADDED: Only show Persona and logout if clientNameParam is valid */}
                {isClientValid ? (
                  <>
                    <div style={{ marginTop: "5px" }}>
                      <Persona
                        {...personaProps}
                        size={PersonaSize.size32} // Adjust size as needed
                        imageAlt="User profile picture"
                      />
                    </div>
                    {/* <i
                      className="fa-solid fa-right-from-bracket mt-2"
                      title="Logout"
                      style={{cursor:"pointer"}}
                      onClick={() =>
                        dispatch(
                          logoutUser({
                            userId: userObj?.userId,
                            userIdentifier: userObj?.userEmail,
                          })
                        )
                      }
                    ></i> */}
                  </>
                ) : null}
          
                
                {/* <button type="button" onClick={() => dispatch(clearUser())}>
                    LOGOUT
                  </button> */}
              </div>
            </div>
          </div>
        </div>
      </nav>
     
    </>
  );
};
export default Header;
